import {createContext, useContext, useContextSelector} from 'use-context-selector'
import _ from 'lodash'

const FormContext = createContext({})
export const {Provider} = FormContext

export const useForm = () => {
	return useContext(FormContext)
}

export const useFormSelector = selector => {
	const normalizedSelector = _.isFunction(selector) ? selector : ctx => _.get(ctx, selector)
	return useContextSelector(FormContext, normalizedSelector)
}

export const useFormData = () => {
	return useFormSelector('fields') || {}
}

export const useFieldValue = field => {
	return useFormSelector(`fields.${field}`)
}
